import errorHandler from "./error";
import {AxiosResponse} from "axios";

export const responseHandler = async <E>(request: Promise<AxiosResponse>, rawData?: boolean): Promise<E> => {
    return new Promise<E>(async (resolve, reject) => {
        request
            .then(response => {
                if (response.status === 200)
                    resolve(rawData ? response.data : response.data['data'] || response.data as E)
                else {
                    console.log(response.data)
                    reject({...response.data, status: response.status})
                }
            }).catch(reason => errorHandler(reason, reject))
    })
}